module.exports = __webpack_public_path__ + "static/berkshire-logo-f2d60476723900d74c7fa87719589dd7.png";